import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { HomeButton } from "../../pages/MemoryPalAILearnMore";
import ArchetypeStockShelf from "./ArchetypeStockShelf";

import Jungian12DisplayAllMain from "../assets/Jungian12DisplayAllMain.png";
import carl12archetypesShadow from "../assets/carl12archetypesShadow.png";
import ArchetypeArena4Gamers from "../assets/ArchetypeArena4Gamers.png";
import BoyCarebearLoverGirlMagcician from "../assets/BoyCarebearLoverGirlMagcician.png";
import FourKidsPlayingARSageMainCrowdBG from "../assets/FourKidsPlayingARSageMainCrowdBG.png";
import TwelvePlanetBattle from "../assets/TwelvePlanetBattle.png";
import new12jungian from "../assets/new12jungian.gif";
import PinkDragon from "../assets/PinkDragon.png";
import shieldProjectionGlassesSolo from "../assets/shieldProjectionGlassesSolo2.png";
import PostedCarsGroupBG from "../assets/PostedCarsGroupBG.png";
import SilverEverymanSolo from "../assets/SilverEverymanSolo.png";
import MyLittleBuddies from "../assets/MyLittleBuddies.png";

const CONCEPT_STOCK = [
  {
    src: Jungian12DisplayAllMain,
    name: "Jungian Twelve Display",
    line: "Full roster mural. All twelve, lit and locked.",
  },
  {
    src: MyLittleBuddies,
    name: "My Little Buddies",
    line: "12 archetype interactive baby dolls — AI talk, LED eyes, BLE + app.",
    detail: `My Little Buddies: 12 Archetype Interactive Baby Dolls
Model MLB-12BD-001 · Ages 3+

• 12 dolls, one for each Jungian archetype
• AI conversation mode (cloud, encrypted)
• Real baby sounds, feed & respond, LED eyes
• BLE 5.2 + My Little Buddies app
• USB-C rechargeable · up to 8 hrs play / 7 days standby
• PVC / ABS / polyester · ASTM F963-17, CPSIA, EN71

Includes: story book, birth certificate, story cards, themed accessory, headwear, USB-C cable.

Built to encourage empathy, nurturing skills, and imagination.`,
  },
  {
    src: carl12archetypesShadow,
    name: "Shadow Archive",
    line: "Shadow set. The other half of the story, still glowing.",
  },
  {
    src: ArchetypeArena4Gamers,
    name: "Marble Minds",
    line: "Physical character marbles unlock AI play in Archetype Arena.",
    detail: `A hybrid game: collect real marbles, play in a virtual Archetype Arena.

• Each marble = a unique AI archetype personality
• Physical marble = your key into the virtual world
• Trade marbles, unlock abilities, take on challenges
• Battle, quest, and interact with your AI archetype
• More marbles → a stronger archetype roster
• Marbles as collectables / NFTs — train, trade, sell

Sizes
• Standard — 25mm / 1"
• Toe breaker — 60mm / 2.36"
• Giant — 60mm+

Builds
• V1 — Clear epoxy sphere, 2D image both sides (live)
• V2 — Lenticular 3D in epoxy (TBD)
• V3 — AR + lenticular in epoxy (TBD)

Why it hits: toy-collecting nostalgia + AI + AR + blockchain.`,
  },
  {
    src: BoyCarebearLoverGirlMagcician,
    name: "Character Duo",
    line: "Dual-cast concept. Soft meets spellwork.",
  },
  {
    src: FourKidsPlayingARSageMainCrowdBG,
    name: "AR Playground",
    line: "AR field test. Kids, crowd, and a Sage in the mix.",
  },
  {
    src: TwelvePlanetBattle,
    name: "Planet Battle",
    line: "Twelve-world war map. Cosmic shelf candy.",
  },
  {
    src: new12jungian,
    name: "Living Twelve",
    line: "Animated twelve. Watch the archetypes breathe.",
  },
  {
    src: PinkDragon,
    name: "Pink Dragon",
    line: "AR companion concept — an AI pet living in your space. Everyman skin, owner's pick.",
    detail: `Pink Dragon is a concept for an AR character you own and live with — an AI pet that exists in your personal space.

You interact with it day to day. The archetype shown here is the Everyman; that look is simply the form this owner chose. Another owner could cast a different archetype as the same kind of companion.

It's a concept piece about presence, ownership, and how an archetype can feel like a roommate rather than a menu icon.`,
  },
  {
    src: shieldProjectionGlassesSolo,
    name: "Shield Glasses",
    line: "Projection shields. Future eyewear, present vibe.",
  },
  {
    src: PostedCarsGroupBG,
    name: "The Devil vacations in PR",
    line: "",
  },
  {
    src: SilverEverymanSolo,
    name: "Archetype Morph",
    line: "Silver Everyman. Everyday hero, polished finish.",
  },
];

export default function Products() {
  const [activeName, setActiveName] = useState(null);
  const [preview, setPreview] = useState(null);

  const inspect = (item) => {
    setActiveName(item.name);
    setPreview(item);
  };

  return (
    <Page>
      <HomeButton to="/">Home</HomeButton>

      <Storefront>
        <CeilingLights />
        <NeonSign>
          <SignGlow>THE FUTURE STORE</SignGlow>
          <SignSub>OPEN · VIRTUAL HOURS · ALWAYS</SignSub>
        </NeonSign>

        <ArchetypeStockShelf />
        <ConceptWing>
          <WingHeader>
            <WingTitle>CONCEPT WALL</WingTitle>
            <WingCopy>Same creations, displayed as holographic storefront posters.</WingCopy>
          </WingHeader>
          <PosterWall>
            {CONCEPT_STOCK.map((item) => (
              <PosterFrame
                key={item.name}
                type="button"
                $active={activeName === item.name}
                onClick={() => inspect(item)}
                aria-label={`Inspect ${item.name}`}
              >
                <img src={item.src} alt={item.name} />
                <PosterMeta>
                  <strong>{item.name}</strong>
                  {item.line ? <em>{item.line}</em> : null}
                </PosterMeta>
              </PosterFrame>
            ))}
          </PosterWall>
        </ConceptWing>
      </Storefront>

      {preview && (
        <PreviewOverlay onClick={() => setPreview(null)} role="presentation">
          <PreviewCard onClick={(e) => e.stopPropagation()}>
            <PreviewImg src={preview.src} alt={preview.name} />
            <PreviewInfo>
              <h3>{preview.name}</h3>
              {preview.line ? <p>{preview.line}</p> : null}
              {preview.detail && (
                <DetailBody>
                  {preview.detail
                    .trim()
                    .split(/\n\n+/)
                    .map((block, i) => (
                      <p key={i}>{block}</p>
                    ))}
                </DetailBody>
              )}
              <CloseBtn type="button" onClick={() => setPreview(null)}>
                Close
              </CloseBtn>
            </PreviewInfo>
          </PreviewCard>
        </PreviewOverlay>
      )}
    </Page>
  );
}

const flicker = keyframes`
  0%, 19%, 21%, 23%, 25%, 54%, 56%, 100% { opacity: 1; }
  20%, 24%, 55% { opacity: 0.72; }
`;

const scan = keyframes`
  0% { background-position: 0 0; }
  100% { background-position: 0 40px; }
`;

const Page = styled.div`
  min-height: 100vh;
  background: transparent;
  color: #e8ffe9;
  overflow-x: hidden;
`;

const Storefront = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 1.25rem 1rem 0;
  background: transparent;

  &::before {
    content: "";
    pointer-events: none;
    position: absolute;
    inset: 0;
    background-image: linear-gradient(
      rgba(69, 254, 71, 0.03) 1px,
      transparent 1px
    );
    background-size: 100% 4px;
    animation: ${scan} 8s linear infinite;
    opacity: 0.35;
    z-index: 0;
  }
`;

const CeilingLights = styled.div`
  position: absolute;
  top: 0;
  left: 10%;
  right: 10%;
  height: 8px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(69, 254, 71, 0.55),
    rgba(120, 255, 220, 0.4),
    rgba(69, 254, 71, 0.55),
    transparent
  );
  filter: blur(1px);
  z-index: 1;
`;

const NeonSign = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  margin: 3.5rem auto 1.25rem;
  padding: 0.75rem 1.5rem;
`;

const SignGlow = styled.h1`
  margin: 0;
  font-family: "Orbitron", sans-serif;
  font-weight: 700;
  font-size: clamp(1.4rem, 4vw, 2.75rem);
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: #45fe47;
  text-shadow:
    0 0 8px rgba(69, 254, 71, 0.85),
    0 0 24px rgba(69, 254, 71, 0.45),
    0 0 48px rgba(69, 254, 71, 0.25);
  animation: ${flicker} 4.5s infinite;
`;

const SignSub = styled.div`
  margin-top: 0.45rem;
  font-family: "VT323", monospace;
  font-size: 1.1rem;
  letter-spacing: 0.35em;
  color: rgba(69, 254, 71, 0.7);
`;

const ConceptWing = styled.section`
  position: relative;
  z-index: 2;
  padding: 0.5rem 0 3.5rem;
  background: transparent;
`;

const WingHeader = styled.div`
  max-width: 1200px;
  margin: 0 auto 1.5rem;
  text-align: center;
`;

const WingTitle = styled.h2`
  margin: 0;
  font-family: "Orbitron", sans-serif;
  font-weight: 600;
  font-size: clamp(1.1rem, 2.5vw, 1.6rem);
  letter-spacing: 0.22em;
  color: #45fe47;
`;

const WingCopy = styled.p`
  margin: 0.55rem auto 0;
  max-width: 34rem;
  font-family: "VT323", monospace;
  font-size: 1.2rem;
  color: rgba(232, 255, 233, 0.7);
`;

const PosterWall = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  gap: 1.25rem;
`;

const PosterFrame = styled.button`
  appearance: none;
  width: 100%;
  padding: 0;
  border: 1px solid
    ${({ $active }) =>
      $active ? "rgba(69, 254, 71, 0.95)" : "rgba(69, 254, 71, 0.28)"};
  background: #000;
  cursor: pointer;
  overflow: hidden;
  text-align: left;
  transition: border-color 0.2s ease, transform 0.2s ease;
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.8),
    0 0 30px rgba(69, 254, 71, 0.08);

  img {
    display: block;
    width: 100%;
    height: auto;
  }

  &:hover {
    border-color: rgba(69, 254, 71, 0.75);
    transform: translateY(-2px);
  }

  &:focus-visible {
    outline: 2px solid #45fe47;
    outline-offset: 3px;
  }
`;

const PosterMeta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.2rem;
  padding: 0.55rem 0.75rem;
  background: linear-gradient(90deg, #07140c, #050807);
  border-top: 1px solid rgba(69, 254, 71, 0.22);
  font-family: "VT323", monospace;

  strong {
    color: #45fe47;
    letter-spacing: 0.08em;
    font-weight: 400;
    font-size: 1.15rem;
  }

  em {
    font-style: normal;
    color: rgba(157, 255, 159, 0.65);
    font-size: 1rem;
    line-height: 1.25;
  }
`;

const PreviewOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
`;

const PreviewCard = styled.div`
  width: min(920px, 100%);
  max-height: 92vh;
  overflow: auto;
  background: #050807;
  border: 2px solid #45fe47;
  box-shadow: 0 0 40px rgba(69, 254, 71, 0.2);
`;

const PreviewImg = styled.img`
  display: block;
  width: 100%;
  height: auto;
  max-height: 70vh;
  object-fit: contain;
  background: #000;
`;

const PreviewInfo = styled.div`
  padding: 1rem 1.1rem 1.2rem;
  font-family: "VT323", monospace;

  h3 {
    margin: 0 0 0.35rem;
    color: #45fe47;
    letter-spacing: 0.12em;
    font-size: 1.4rem;
    font-weight: 400;
  }

  > p {
    margin: 0 0 0.9rem;
    color: #f2fff2;
    font-size: 1.2rem;
    line-height: 1.3;
  }
`;

const DetailBody = styled.div`
  margin: 0 0 1rem;
  padding-top: 0.35rem;
  border-top: 1px solid rgba(69, 254, 71, 0.22);

  p {
    margin: 0 0 0.75rem;
    color: rgba(232, 255, 233, 0.82);
    font-size: 1.05rem;
    line-height: 1.35;
    white-space: pre-line;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

const CloseBtn = styled.button`
  appearance: none;
  border: 1px solid #45fe47;
  background: #45fe47;
  color: #050807;
  font-family: "VT323", monospace;
  font-size: 1.15rem;
  letter-spacing: 0.12em;
  padding: 0.45rem 1rem;
  cursor: pointer;

  &:hover {
    background: #000;
    color: #45fe47;
  }
`;
